import React from 'react';
import PropTypes from 'prop-types';

import { truncateWallet, formatDate } from '../../utils';
import Status from './Status';
import styles from './index.module.css';

const MobileRow = ({ withdrawal }) => {
  const { date, wallet, network, amount, convertedAmount, status } = withdrawal;

  return (
    <div className={styles.mobileRow}>
      <div className={styles.mobileRowLeft}>
        <div className={styles.mobileAmountRow}>
          <span className={styles.amountPrimary}>
            {amount.value} {amount.currency}
          </span>
          <span className={styles.amountSecondaryInline}>
            {convertedAmount.value} {convertedAmount.currency}
          </span>
        </div>
        <div className={styles.mobileWalletNetwork}>
          {truncateWallet(wallet)} | {network}
        </div>
      </div>
      <div className={styles.mobileRowRight}>
        <Status value={status} />
        <div className={styles.mobileDate}>{formatDate(date)}</div>
      </div>
    </div>
  );
};

MobileRow.propTypes = {
  withdrawal: PropTypes.shape({
    id: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    wallet: PropTypes.string.isRequired,
    network: PropTypes.string.isRequired,
    amount: PropTypes.shape({
      value: PropTypes.string.isRequired,
      currency: PropTypes.string.isRequired,
    }).isRequired,
    convertedAmount: PropTypes.shape({
      value: PropTypes.string.isRequired,
      currency: PropTypes.string.isRequired,
    }).isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
};

export default MobileRow;
